import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import tw from "twin.macro";
import Hero from "../hero";
import Leading from "./leading";
import OrgChart from "./org-chart";
import About from "./about";
import Collaboration from "./collaboration";
import Frontier from "./frontier";
import UW from "./uw";

const Wrapper = tw.div`container mx-auto`;
const SideBySide = tw.div`mx-auto max-w-5xl grid md:grid-cols-2 gap-6 mb-6`;

const TeamContent = () => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "team-banner.jpeg" }) {
        childImageSharp {
          # Specify a fixed image and fragment.
          # The default width is 400 pixels
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
    <>
      <Hero imgQuery={data.file.childImageSharp.fluid}>Our Team</Hero>
      <Leading />
      <Wrapper>
        <OrgChart />
        <Collaboration />
        <SideBySide>
          <UW />
          <Frontier />
        </SideBySide>
        <About />
      </Wrapper>
    </>
  );
};

export default TeamContent;
